/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RowSelectionModeConstants = {
    Exactly: 'Exactly',
    AllExcept: 'AllExcept'
} as const;
export type RowSelectionModeConstants = typeof RowSelectionModeConstants[keyof typeof RowSelectionModeConstants];


export function RowSelectionModeConstantsFromJSON(json: any): RowSelectionModeConstants {
    return RowSelectionModeConstantsFromJSONTyped(json, false);
}

export function RowSelectionModeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowSelectionModeConstants {
    return json as RowSelectionModeConstants;
}

export function RowSelectionModeConstantsToJSON(value?: RowSelectionModeConstants | null): any {
    return value as any;
}

